import { useUser } from "src/contexts/user-context";

/**
 * Org-level entitlement keys (`organizations.entitlements` jsonb) read on the
 * frontend. Provisioned by revops via the CS Admin app.
 */
export type OrganizationEntitlementKey =
  | "adStudio"
  | "lifecycleStudio"
  | "dataAgents"
  | "matchbooster";

/**
 * Whether the org has the given entitlement key — grants alongside the
 * corresponding LaunchDarkly flag, by truthiness, matching the backend
 * engine's dbKeys handling.
 *
 * Mirrors the backend's entitlement source (`loadEntitlementInputs` /
 * `organization_overage_dates_for_org()`): when the org has no entitlements
 * payload at all, the billing product's entitlements apply. An explicit
 * payload — even an empty one — takes precedence and is not merged.
 */
export const useOrganizationEntitlement = (
  key: OrganizationEntitlementKey,
): boolean => {
  const { workspace } = useUser();
  const organization = workspace?.organization;
  const entitlements =
    organization?.entitlements ?? organization?.plan?.entitlements;
  return Boolean(entitlements?.[key]);
};
